import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  connectAuthEmulator, 
  browserLocalPersistence, 
  setPersistence,
  signInWithPopup,
  GoogleAuthProvider
} from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { 
  getFirestore, 
  connectFirestoreEmulator, 
  enableIndexedDbPersistence, 
  initializeFirestore, 
  CACHE_SIZE_UNLIMITED,
  persistentLocalCache,
  persistentMultipleTabManager
} from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Declare global window properties for emulator
declare global {
  interface Window {
    FIREBASE_FIRESTORE_EMULATOR_ADDRESS?: string;
    FIREBASE_AUTH_EMULATOR_ADDRESS?: string;
  }
}

// Hard-coded Firebase configuration with correct values
const firebaseConfig = {
  apiKey: "AIzaSyB0vfidk2GB4BJ24ixfWMPNSvRR7ko4RF0",
  authDomain: "iiminterview-iim.firebaseapp.com",
  projectId: "iiminterview-iim",
  storageBucket: "iiminterview-iim.appspot.com", // Corrected from firebasestorage.app
  messagingSenderId: "88668928353",
  appId: "1:88668928353:web:0027eff55d2ed92ed66d20",
  measurementId: "G-1MP1F5Q15L"
};

console.log('Initializing Firebase with project ID:', firebaseConfig.projectId);
console.log('Using API Key:', firebaseConfig.apiKey);
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);

// Initialize Firestore with settings for better performance and reliability
console.log('Initializing Firestore with updated settings');

// Use standard initialization instead of initializeFirestore for production
const db = getFirestore(app);

// Log Firestore initialization
console.log('Firestore initialized:', db ? 'Success' : 'Failed');

const functions = getFunctions(app, 'europe-west1');

let analytics;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.log('Analytics not available in this environment');
  analytics = null;
}

// Set persistence for both development and production
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Successfully set browser persistence for auth');
  })
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });

// Enable Firestore offline persistence for better performance and offline support
if (process.env.NODE_ENV === 'production') {
  console.log('Setting up Firestore for production environment');
  // Persistence is already enabled with persistentLocalCache above
  console.log('Firestore persistence enabled for production');
}

// ##Security: Enhanced development environment configuration
if (process.env.NODE_ENV === 'development') {
  // Connect to emulators with explicit error handling
  try {
    console.log('Setting up Firebase emulators for development environment');
    
    // Connect to emulators - IMPORTANT: This must happen BEFORE any Firestore operations
    connectFirestoreEmulator(db, 'localhost', 7002);
    connectFunctionsEmulator(functions, 'localhost', 7001);
    connectAuthEmulator(auth, 'http://localhost:7003', { disableWarnings: true });
    
    console.log('Successfully connected to Firebase emulators');
    
    // Force CORS preflight for Firestore
    window.FIREBASE_FIRESTORE_EMULATOR_ADDRESS = 'localhost:7002';
    window.FIREBASE_AUTH_EMULATOR_ADDRESS = 'localhost:7003';
    
  } catch (error) {
    console.error('Failed to connect to Firebase emulators:', error);
  }
}

export { app, auth, functions, db, analytics }; 